import React from 'react';
import Moment from 'react-moment';

export const Date = ({ date }) => (
  <div className="time-stamp">
    <Moment date={date} format="DD-MM-YYYY" />
    <span className="ml-2 mr-2" />
    <Moment date={date} format="hh:mm A" />
  </div>
);

export default Date;



// WEBPACK FOOTER //
// ./src/components/Date.js